module.exports = __webpack_public_path__ + "img/13.74a348c1.webp";